import React, { memo, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Select from '@JohnLewisPartnership/jl-design-system/elements/select/Select';
import { PrimaryButton } from '@JohnLewisPartnership/jl-design-system/elements/button/Button';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SORT_OPTION_CHANGED } from '../analytics/analyticsEvents';
import { useAnalyticsData } from '../../hooks/useAnalyticsData';
import { useAnalytics } from '../../hooks/useAnalytics';
import {
  getQueryParams,
  getQueryString,
  facetsFilter,
} from '../stateful-link/StatefulLink';
import { sortOptions } from './options';
import styles from './Sort.module.scss';

const Sort = ({ sort }) => {
  const [isInteractive, setIsInteractive] = useState(false);
  const { pageType } = useAnalyticsData();

  const sortByEvent = useAnalytics(SORT_OPTION_CHANGED, {
    pagetype: pageType,
  });

  const router = useRouter();

  const filteredParams = Object.entries(router.query).filter(
    ([key, val]) => !['page', 'sortBy'].includes(key) && val
  );

  const actionUrl = router.asPath;

  const handleSort = (e) => {
    e.preventDefault();

    const sortBy = e.target.value;

    sortByEvent({ sort: sortBy });

    const { pathname: href, query } = router;

    const { facetId, type } = query;

    if (type === 's') {
      query['search-term'] = facetId[0].replace(/-/g, ' ');
      query.type = 'search';
      delete query.facetId;
    }

    const pathname = type === 's' ? `/search` : document.location.pathname;

    const url = {
      pathname: href,
      query: getQueryParams({ ...query, page: '', sortBy }, facetsFilter()),
    };

    const as = `${pathname}?${getQueryString(url.query)}`;

    router.push(url, as);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setIsInteractive(true);
  }, []);

  return (
    <React.Fragment>
      <div className={styles.sort}>
        <form action={actionUrl} method="GET" className={styles.sort__form}>
          {filteredParams.map(([name, value]) => (
            <input key={name} name={name} value={value} type="hidden" />
          ))}

          <div className={classnames(styles.sort__select)} data-test="sort-by">
            {/* eslint-disable-next-line */}
            <label className={styles.visuallyHidden} htmlFor="sortBy">
              Sort by
            </label>
            <Select
              id="sortBy"
              name="sortBy"
              value={sort}
              onChange={handleSort}
              options={sortOptions}
            />
          </div>
          <PrimaryButton
            type="submit"
            className={classnames(styles.sort__submit, {
              [styles['sort__submit--visible']]: !isInteractive,
            })}
          >
            Go
          </PrimaryButton>
        </form>
      </div>
    </React.Fragment>
  );
};

Sort.defaultProps = {
  sort: '',
};

Sort.propTypes = {
  sort: PropTypes.string,
};

export default memo(Sort);
